@if (facilityUtilisation) {
  <div class="layout-col gap-sm">
    <div class="layout-row">
      <elder-progress-bar
        class="flex"
        [bars]="calculateProgress(facilityUtilisation)"
        [minHeight]="barThickness"
      >
      </elder-progress-bar>
    </div>
    <div
      class="{{ legendHorizontal ? 'layout-row' : 'layout-col' }} {{
        legendHorizontal ? 'place-between-center' : ''
      }}"
    >
      <div class="layout-row place-between-center gap-sm">
        <div class="layout-row place-start-center gap-sm">
          <div style="height: 12px; width: 12px" [style.background-color]="Colors.completed"></div>
          @if (!hideLegendDescription) {
            <span class="text-body-medium"
              >{{ 'manufacturing.scheduling.completed' | translate }}:</span
            >
          }
        </div>
        <span class="text-body-medium">{{
          getCompletedWeight(facilityUtilisation) | elderQuantity
        }}</span>
      </div>
      <div class="layout-row place-between-center gap-sm">
        <div class="layout-row place-start-center gap-sm">
          <div style="height: 12px; width: 12px" [style.background-color]="Colors.progress"></div>
          @if (!hideLegendDescription) {
            <span class="text-body-medium"
              >{{ 'manufacturing.scheduling.progress' | translate }}:</span
            >
          }
        </div>
        <span class="text-body-medium">{{
          getInProgressWeight(facilityUtilisation) | elderQuantity
        }}</span>
      </div>
      <div class="layout-row place-between-center gap-sm">
        <div class="layout-row place-start-center gap-sm">
          <div
            style="height: 12px; width: 12px"
            [style.background-color]="Colors.readyForProduction"
          ></div>
          @if (!hideLegendDescription) {
            <span class="text-body-medium"
              >{{ 'manufacturing.scheduling.readyForProduction' | translate }}:</span
            >
          }
        </div>
        <span class="text-body-medium">{{
          getReadyWeight(facilityUtilisation) | elderQuantity
        }}</span>
      </div>
      <div class="layout-row place-between-center gap-sm">
        <div class="layout-row place-start-center gap-sm">
          <div style="height: 12px; width: 12px" [style.background-color]="Colors.onHold"></div>
          @if (!hideLegendDescription) {
            <span class="text-body-medium"
              >{{ 'manufacturing.scheduling.onHold' | translate }}:</span
            >
          }
        </div>
        <span class="text-body-medium">{{
          getOnHoldWeight(facilityUtilisation) | elderQuantity
        }}</span>
      </div>
    </div>
  </div>
}
